import api from "./api";

export const fetchAllEmployees = async (loggedInUserTypeId) => {
  try {
    let result = await api.get("/Users/details", {
      headers: {
        "Content-Type": "multipart/form-data",
      },
    });
    return result?.data;
  } catch (error) {
    throw error;
  }
};

export const getEmployeeById = async (loggedInUserTypeId, id) => {
  try {
    const response = await api.get(
      `/Users/${id}?loggedInUserTypeId=${loggedInUserTypeId}`,
      {
        headers: {
          "Content-Type": "multipart/form-data",
        },
      }
    );
    return response?.data;
  } catch (error) {
    throw error;
  }
};
export const toggleEmployeeStatus = async (loggedInUserTypeId, flag, id) => {
  try {
    const response = await api.put(
      `/Users/status/${id}?isActive=${flag}&loggedInUserTypeId=${loggedInUserTypeId}`,
      {
        headers: {
          "Content-Type": "multipart/form-data",
        },
      }
    );
    return response?.data?.result;
  } catch (error) {
    throw error;
  }
};

export const deleteEmployeeDetails = async(loggedInUserTypeId,id)=>{
  try {
    const response = await api.delete(`/Users/${id}?loggedInUserTypeId=${loggedInUserTypeId}`, {
      headers: {
        "Content-Type": "multipart/form-data",
      },
    });
    return response?.data;
  } catch (error) {
    throw error;
  }
}
export const addEmployeeDetails = async (loggedInUserTypeId, form) => {
  try {
    const response = await api.post(
      `/Users?loggedInUserTypeId=${loggedInUserTypeId}`,
      form,
      {
        headers: {
          "Content-Type": "application/json",
        },
      }
    );
    return response?.data;
  } catch (error) {
    console.error("Error editing project:", error);
    throw error; // This rethrows the error to propagate to getProjectById's catch block
  }
};
export const updateEmployeeDetails = async (loggedInUserTypeId, form, id) => {
  try {
    const response = await api.put(
      `/Users/${id}?loggedInUserTypeId=${loggedInUserTypeId}`,
      form,
      {
        headers: {
          "Content-Type": "application/json",
        },
      }
    );
    return response?.data;
  } catch (error) {
    console.error("Error editing project:", error);
    throw error; // This rethrows the error to propagate to getProjectById's catch block
  }
};

export const allUsers = async () => {
  try {
    let result = await api.get("/Users", {
      headers: {
        "Content-Type": "multipart/form-data",
      },
    });
    return result?.data;
  } catch (error) {
    throw error;
  }
};
